import { TablesUpdate } from "@/lib/supabase/supabase_types_override";
import { supabase } from "@/lib/supabase/supabaseClient";

export const updateCrmProject = async (data: TablesUpdate<'crm_project'>) => {
    const { id, ...dataWithoutId } = data;
    return await supabase.from("crm_project").update(dataWithoutId).eq("id", id!).throwOnError();
}